<div class="row">
  <div class="col-12 p-0">
    <div class="row border Page-Header py-1 align-items-center" style="background: #0c4788;">
      <div class="col-12">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
          <!-- LEFT: Info + Change Course -->
          <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap gap-1 gap-md-4">
            <h6 class="px-2 text-white mb-0"><strong>Content Management :</strong> {{ getAnchorLabel(ScreenName) }}</h6>
            <h6 class="text-white mb-0" *ngIf="ExamAgencyName"><strong>Exam Agency:</strong> {{ ExamAgencyName }}</h6>
            <h6 class="text-white mb-0" *ngIf="CourseName"><strong>Course:</strong> {{ CourseName }}</h6>
            <h6 class="text-white mb-0" *ngIf="ExamYear"><strong>Year:</strong> {{ ExamYear }}</h6>
            <button
              type="button"
              class="btn btn-sm ms-0 ms-md-2 mt-2 mt-md-0"
              style="background: #fff; color: #0c4788; border: 1px solid #fff;"
              (click)="open()"
            >
              Change Course
            </button>
          </div>
          <!-- RIGHT: Refresh & Language -->
          <div class="d-flex flex-column flex-md-row align-items-center gap-2 mt-2 mt-md-0">
            <!-- <button
              type="button"
              class="btn btn-sm w-100 w-md-auto"
              style="background: #fff; color: #0c4788; border: 1px solid #fff;"
              (click)="refreshPage()"
            >
              Refresh
            </button>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="appser.userlanuage"
              style="background: #0c4788; color: #fff; border-color: #fff;"
            >
              <option *ngFor="let d of lanuage" [ngValue]="d" class="text-dark">{{ d }}</option>
            </select> -->
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="col-12" >
    <div class="row border-bottom d-flex align-items-center">
      <div class="d-flex align-items-center">
      <div class="py-2 p-1" [ngClass]="ScreenName === 'CLONE' ? 'col-12' : 'col-2'">
        <!-- style="min-width: 600px !important;max-width: 600px !important;" -->
        <select
        *ngIf="ScreenName==='Display Order' || ScreenName==='Main Topics'"
          class="form-control form-control-sm"
          [(ngModel)]="selectedsubject"
          (change)="SelectSubject($event)"
        >
          <option selected value="0">Select Subject</option>
          <option
            class="border-bottom"
            *ngFor="let s of subject; let i = index"
            [value]="s.ID"
          >
            {{ s.Name }}
          </option>
        </select>
        <select
        *ngIf="ScreenName!=='Display Order' && ScreenName !=='Main Topics' && ScreenName !== 'CLONE'"
          class="form-control form-control-sm"
          [(ngModel)]="selectedsubject"
          (change)="SelectSubject($event)"
        >
          <option hidden value="0">Select Subject</option>
          <option
            class="border-bottom"
            *ngFor="let s of subject; let i = index"
            [value]="s.ID"
          >
            {{ s.Name }}
          </option>
        </select>

        <div *ngIf="ScreenName === 'CLONE'" class="clone-subject-wrap">
          <div *ngIf="cloneSelection?.subjectName || cloneSubjectName" class="clone-selected-strip">
            <div class="clone-selected-item">
              <span class="clone-selected-label">Exam Agency</span>
              <span class="clone-selected-value">{{ cloneSelection?.examAgency?.Name || 'Not Selected' }}</span>
            </div>
            <div class="clone-selected-item">
              <span class="clone-selected-label">Course</span>
              <span class="clone-selected-value">{{ cloneSelection?.course?.Name || 'Not Selected' }}</span>
            </div>
            <div class="clone-selected-item">
              <span class="clone-selected-label">Year</span>
              <span class="clone-selected-value">{{ cloneSelection?.year?.Name || 'Not Selected' }}</span>
            </div>
            <div class="clone-selected-item clone-selected-item--subject">
              <span class="clone-selected-label">Subject</span>
              <span class="clone-selected-value">{{ cloneSelection?.subjectName || cloneSubjectName || 'Not Selected' }}</span>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-sm bl-btn clone-subject-btn ms-auto"
            (click)="openCloneSelector()"
          >
            Select Subject
          </button>
        </div>
      </div>
      <div class="col-1 py-2 p-1" *ngIf="selectedsubject && ScreenName !== 'CLONE'">
        <div class="d-flex">
          <div class="p-0" *ngIf="ScreenName!=='Display Order' || ScreenName!=='Main Topics'">
            <button
              type="button"
              class="btn btn-sm py-0 px-1"
              (click)="RefreshActivity()"
            >
              <i
                class="fa1 fa fa-refresh"
                title="Refresh"
                aria-hidden="true"
              ></i>
            </button>
          </div>
          <div class="p-0" *ngIf="ScreenName!=='Display Order' || ScreenName!=='Main Topics'">
            <button type="button" class="btn btn-sm py-0 px-1">
              <i
                class="fa1 fa fa-search"
                title="Search"
                aria-hidden="true"
                (click)="SearchActivity()"
              ></i>
            </button>
          </div>

          <!-- <div class="p-0 px-1" *ngIf="ScreenName!=='Display Order'">
            <button
              type="button"
              class="btn btn-sm bg-light border"
              (click)="ViewActivityHistory()"
            >
              Activity History
            </button>

          </div> -->
        </div>
      </div>
      <div class="col-7" *ngIf="Note" >
          <span style="color:red">
          Note:  {{Note}}
          </span>
      </div>
      </div>

    </div>
    <!-- <div class="col-12 px-1">
    <div class="px-1 tree-btn-1">
      <button type="button"
          class="tree-btn" (click)="AddStudyUnit(100066)">
          <i class="fa fa-plus"></i>
      </button>
    </div>
  </div> -->
    <!-- <div class="row pt-1" >
      <div class="col-12"> -->
    <div class="row border Page-Header" *ngIf="ScreenName==='Report' && selectedsubject && selectedsubject !== '0'">
      <div class="col-12 px-1 pt-0 pb-2 scroll-style">
        <app-study-unit-practice-question-report-table
          [rows]="studyUnitPracticeQuestionReport"
          (assignPracticeQuestion)="openAssignPracticeQuestion($event)"
          (editStudyUnit)="openEditStudyUnitFromReport($event)"
          (editStudyMaterial)="openEditStudyMaterialFromReport($event)"
        ></app-study-unit-practice-question-report-table>
      </div>
    </div>

    <div class="row border Page-Header" *ngIf="ScreenName === 'CLONE' && cloneRowsLoaded">
      <div class="col-12 px-2 py-2 scroll-style">
        <div *ngIf="cloneTopicGroups.length === 0" class="text-center py-3">
          No Study Units available for cloning.
        </div>

        <div *ngFor="let group of cloneTopicGroups" class="mb-3">
          <div class="d-flex align-items-center gap-3 mb-1 clone-topic-header">
            <span class="fw-bold">Major Topic Name</span>
            <span>{{ group.majorTopicName }}</span>
          </div>

          <table class="table table-bordered table-hover mb-0 clone-grid-table">
            <thead>
              <tr class="table-active">
                <th class="text-center" style="width: 10%;">From Study</th>
                <th class="text-center" style="width: 40%;">From Study Unit Name</th>
                <th class="text-center" style="width: 10%;">To Study Unit</th>
                <th class="text-center" style="width: 30%;">To Study Unit Name</th>
                <th class="text-center" style="width: 10%;">Clone?</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of group.rows">
                <td class="text-center">{{ row.fromStudyUnitId }}</td>
                <td>{{ row.fromStudyUnitName }}</td>
                <td class="text-center">{{ row.toStudyUnitId }}</td>
                <td>{{ row.toStudyUnitName }}</td>
                <td class="text-center">
                  <input
                    type="checkbox"
                    [(ngModel)]="row.selected"
                    [disabled]="isCloneRowDisabled(group, row)"
                    (change)="onCloneRowSelectionChange(group, row, $event)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-center gap-2 py-2" *ngIf="cloneTopicGroups.length > 0">
          <button type="button" class="btn btn-sm bl-btn" [disabled]="!isCloneActionEnabled()" (click)="proceedClone()">Clone</button>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="ScreenName!=='Display Order'&& ScreenName!=='Main Topics'&& ScreenName!=='Report' && ScreenName !== 'CLONE'">
      <div class="col-12 px-1">
        <div class="row">
          <div
            class="col-12 scrollable-box"
            *ngIf="MajorTopic"
          >
            <div
              class="row tree-row"
              *ngFor="let MT of MajorTopic; let i = index"
              (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
            >
              <div class="col-12 d-flex">
                <div
                  class="px-1 tree-btn-1"
                  *ngIf="
                    MT.ChildNodeExistInd === 'Y' && MT.Study_Unit_Ind === 'N'
                  "
                >
                  <button
                    type="button"
                    class="tree-btn"
                    attr.id="plusMT{{ i }}"
                    (click)="getsubjectData(MT.ID, 'C', i)"
                  >
                    <i class="fa fa-angle-right" *ngIf="!MT.Data"></i
                    ><i class="fa fa-angle-down" *ngIf="MT.Data"></i>
                  </button>
                </div>
                <div
                  class="px-1 tree-btn-1"
                  *ngIf="
                    MT.ChildNodeExistInd === 'Y' && MT.Study_Unit_Ind === 'Y'
                  "
                >
                  <button
                    type="button"
                    class="tree-btn"
                    attr.id="plusMT{{ i }}"
                    (click)="getStudyMaterial(MT.ID)"
                  >
                    <i
                      class="fa fa-angle-right"
                      *ngIf="selectedstudyunit != MT.ID"
                    >
                    </i
                    ><i
                      class="fa fa-angle-down"
                      *ngIf="selectedstudyunit == MT.ID"
                    ></i>
                  </button>
                </div>
                <div
                  class="px-1 tree-btn-1"
                  *ngIf="
                    MT.ChildNodeExistInd === 'N' && MT.Study_Unit_Ind === 'Y'
                  "
                >
                  <button
                    type="button"
                    class="tree-btn"
                    attr.id="plusMT{{ i }}"
                    [hidden]="MT.ChildNodeExistInd === 'N'"
                    (click)="getsubjectData(MT.ID, 'C', i)"
                  >
                    <i class="fa fa-angle-right" *ngIf="!MT.Data"></i
                    ><i class="fa fa-angle-down" *ngIf="MT.Data"></i>
                  </button>
                </div>
                <div
                  class="px-1 tree-btn-1"
                  *ngIf="
                    MT.ChildNodeExistInd === 'N' && MT.Study_Unit_Ind === 'N'
                  "
                >
                  <button
                    type="button"
                    class="tree-btn"
                    attr.id="plusMT{{ i }}"
                    [hidden]="MT.ChildNodeExistInd === 'N'"
                    (click)="getsubjectData(MT.ID, 'C', i)"
                  >
                    <i class="fa fa-angle-right" *ngIf="!MT.Data"></i
                    ><i class="fa fa-angle-down" *ngIf="MT.Data"></i>
                  </button>
                </div>
                <app-tree-content
                  Text="{{ MT.Name }}"
                  status="{{ MT.Status_Code }}"
                  ID="{{ MT.ID }}"
                  (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                ></app-tree-content>

                <!-- ADD STUDY  MATERIAL ICON 1 START -->
                <div
                  class="px-1 tree-btn-1"
                  *ngIf="
                    MT.Study_Unit_Ind === 'N' &&
                    enableedit &&
                    selectedvalue == MT.ID &&
                    selectedkey === 'MT' &&
                    ScreenName == 'STUDY UNIT'
                  "
                  (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                >
                  <button
                    type="button"
                    [hidden]="
                      MT.ChildNodeExistInd === 'N' && MT.Study_Unit_Ind === 'N'&&
                      ScreenName == 'STUDY UNIT'
                    "
                    (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                    attr.id="viewquestion{{ i }}"
                    class="tree-btn"
                    *ngIf="
                      MT.Study_Unit_Ind === 'N' &&
                      enableedit &&
                      selectedvalue == MT.ID &&
                      selectedkey === 'MT' &&
                      ScreenName == 'STUDY UNIT'
                    "
                    (click)="AddStudyUnit(MT, 'MT', null)"
                  >
                    <i class="fa fa-plus" title="Add Study Unit"> </i>
                  </button>
                </div>
                <!-- ADD STUDYMATERIAL ICON 1 END -->
                                 <!-- ADD EDIT COURSE MAIN TOPIC START -->
                <div
                  class="px-1 tree-btn-1"
                  *ngIf="
                    MT.Study_Unit_Ind === 'N' &&
                    enableedit &&
                    selectedvalue == MT.ID &&
                    selectedkey === 'MT' &&
                    ScreenName == 'STUDY UNIT'
                  "
                  (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                >
                  <button
                    type="button"
                    (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                    [hidden]="
                      MT.ChildNodeExistInd === 'N' && MT.Study_Unit_Ind === 'N'&&
                      ScreenName == 'STUDY UNIT'
                    "
                    attr.id="viewquestion{{ i }}"
                    class="tree-btn"
                    *ngIf="
                      MT.Study_Unit_Ind === 'N' &&
                      enableedit &&
                      selectedvalue == MT.ID &&
                      selectedkey === 'MT' &&
                      ScreenName == 'STUDY UNIT'
                    "
                    (click)="addEditCourseMainTopic(MT)"
                  >
                    <i class="fa fa-plus-circle" title="Change Course Main Topic" aria-hidden="true"></i>
                  </button>
                </div>
                <!-- ADD EDIT COURSE MAIN TOPIC END -->
                <!-- EDIT STUDY MATERIAL 1 START -->
                <div
                  class="px-1 tree-btn-1"
                  *ngIf="ScreenName == 'STUDY UNIT'"
                  (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                >
                  <button
                    type="button"
                    (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                    attr.id="viewquestion{{ i }}"
                    class="tree-btn"
                    *ngIf="
                      MT.Study_Unit_Ind === 'Y' &&
                      enableedit &&
                      selectedvalue == MT.ID &&
                      ScreenName == 'STUDY UNIT'
                    "
                    (click)="EditStudyUnit(MT, 'MT', null)"
                  >
                    <i class="fa fa-edit" title="Edit Study Unit"></i>
                  </button>
                </div>
                <!-- EDIT STUDY MATERIAL 1 END -->
                <!-- EDIT STUDY MATERIAL 1 START -->
                <div
                  class="px-1 tree-btn-1"
                  *ngIf="ScreenName == 'STUDY UNIT2'"
                  (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                >
                  <button
                    type="button"
                    (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                    attr.id="viewquestion{{ i }}"
                    class="tree-btn"
                    *ngIf="
                      MT.Study_Unit_Ind === 'Y' &&
                      enableedit &&
                      selectedvalue == MT.ID &&
                      ScreenName == 'STUDY UNIT2'
                    "
                    (click)="AddStudyMaterial(MT, 'MT', null)"
                  >
                    <i class="fa fa-plus" title="Add Study Material"></i>
                  </button>
                </div>
                <!-- STUDY UNIT2 LIST START -->
                <div
                  *ngIf="ScreenName == 'STUDY UNIT'"
                  class="px-1 tree-btn-1"
                  (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                >
                  <button
                    type="button"
                    (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
                    attr.id="viewquestion{{ i }}"
                    class="tree-btn"
                    *ngIf="
                      MT.Study_Unit_Ind === 'Y' &&
                      enableedit &&
                      selectedvalue == MT.ID &&
                      ScreenName == 'STUDY UNIT'
                    "
                    (click)="ShowSubjectlist(MT)"
                  >
                    <i class="fa fa-bars" title="Study Unit Subject"></i>
                  </button>
                </div>
                <!-- STUDY UNIT2 LIST END -->
                <!-- ASSIGN STUDY UNIT2 START 1 -->
                <div
                *ngIf="
                  MT.ChildNodeExistInd === 'Y'&&
                  MT.Study_Unit_Ind === 'Y'&&
                  ScreenName == 'STUDY UNIT2'"
                  class="px-1 tree-btn-1"
                  (mouseenter)="OnSelect(MT.ID, MT.Subject_Level_Type_Code)"
              >
                <button
                  type="button"
                  attr.id="viewquestion{{ i }}"
                  class="tree-btn"
                  (mouseenter)="OnSelect(MT.ID, 'MT')"
                  *ngIf="
                  MT.ChildNodeExistInd === 'Y'&&
                    MT.Study_Unit_Ind === 'Y' &&
                    enableedit &&
                    selectedvalue == MT.ID &&
                    ScreenName == 'STUDY UNIT2'
                  "
                  (click)="AssignStudyMaterial(MT)"
                >
                <i class="fa fa-link" title="Assign Study Material"></i>
                </button>
              </div>
                <!-- ASSIGN STUDY UNIT2 END 1 -->

              </div>
              <div class="col-12" *ngIf="MT.Data">
                <div
                  class="row tree-row tree-row-child"
                  *ngFor="let C of MT.Data; let j = index"
                  (mouseenter)="OnSelect(C.ID, C.Subject_Level_Type_Code)"
                >
                  <div class="col-12">
                    <div class="d-flex">
                      <div
                        class="px-1 tree-btn-1"
                        *ngIf="
                          C.ChildNodeExistInd === 'Y' &&
                          C.Study_Unit_Ind === 'N'
                        "
                      >
                        <button
                          type="button"
                          class="tree-btn"
                          (click)="getsubjectData(C.ID, 'SC1', i, j)"
                          attr.id="plusC{{ i }}"
                          [hidden]="C.ChildNodeExistInd === 'N'"
                        >
                          <i class="fa fa-angle-right" *ngIf="!C.Data"></i
                          ><i class="fa fa-angle-down" *ngIf="C.Data"></i>
                        </button>
                      </div>
                      <div
                        class="px-1 tree-btn-1"
                        *ngIf="
                          C.ChildNodeExistInd === 'Y' &&
                          C.Study_Unit_Ind === 'Y'
                        "
                      >
                        <button
                          type="button"
                          class="tree-btn"
                          (click)="getStudyMaterial(C.ID)"
                          attr.id="plusC{{ i }}"
                          [hidden]="C.ChildNodeExistInd === 'N'"
                        >
                          <i
                            class="fa fa-angle-right"
                            *ngIf="selectedstudyunit != C.ID"
                          ></i>
                          <i
                            class="fa fa-angle-down"
                            *ngIf="selectedstudyunit == C.ID"
                          ></i>
                        </button>
                      </div>
                      <div
                        class="px-1 tree-btn-1"
                        *ngIf="
                          C.ChildNodeExistInd === 'N' &&
                          C.Study_Unit_Ind === 'Y'
                        "
                      >
                        <button
                          type="button"
                          class="tree-btn"
                          (click)="getsubjectData(C.ID, 'SC1', i, j)"
                          attr.id="plusC{{ i }}"
                          [hidden]="C.ChildNodeExistInd === 'N'"
                        >
                          <i class="fa fa-angle-right" *ngIf="!C.Data"></i
                          ><i class="fa fa-angle-down" *ngIf="C.Data"></i>
                        </button>
                      </div>
                      <div
                        class="px-1 tree-btn-1"
                        *ngIf="
                          MT.ChildNodeExistInd === 'N' &&
                          MT.Study_Unit_Ind === 'N'
                        "
                      >
                        <button
                          type="button"
                          class="tree-btn"
                          (click)="getsubjectData(C.ID, 'SC1', i, j)"
                          attr.id="plusC{{ i }}"
                          [hidden]="C.ChildNodeExistInd === 'N'"
                        >
                          <i class="fa fa-angle-right" *ngIf="!C.Data"></i
                          ><i class="fa fa-angle-down" *ngIf="C.Data"></i>
                        </button>
                      </div>
                      <app-tree-content
                        Text="{{ C.Name }}"
                        status="{{ C.Status_Code }}"
                        ID="{{ C.ID }}"
                        (mouseenter)="OnSelect(C.ID, 'C')"
                      >
                      </app-tree-content>
                      <!-- ADD STUDY MATERIAL START 2 -->
                      <div
                        class="px-1 tree-btn-1"
                        *ngIf="
                          C.Study_Unit_Ind === 'N' &&
                          enableedit &&
                          selectedvalue == C.ID&&
                          ScreenName == 'STUDY UNIT' &&
                          (selectedkey === 'C' || selectedkey == 'SCL1')
                        "
                        (mouseenter)="OnSelect(C.ID, 'C')"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          [hidden]="
                            C.ChildNodeExistInd === 'N' &&
                            C.Study_Unit_Ind === 'N'
                          "
                          (mouseenter)="OnSelect(C.ID, 'C')"
                          *ngIf="
                            C.Study_Unit_Ind === 'N' &&
                            enableedit &&
                            selectedvalue == C.ID &&
                            (selectedkey === 'C' || selectedkey == 'SCL1') &&
                            ScreenName == 'STUDY UNIT'
                          "
                          (click)="AddStudyUnit(C, 'C', i, j)"
                        >
                          <i class="fa fa-plus" title="Add Study Unit"></i>
                        </button>
                      </div>
                      <!-- ADD STUDY MATERIAL 2 END -->
                       <!-- EDIT STUDY MATERIAL 2 START -->
                      <div
                        class="px-1 tree-btn-1"
                        *ngIf="ScreenName == 'STUDY UNIT'"
                        (mouseenter)="OnSelect(C.ID, 'C')"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          (mouseenter)="OnSelect(C.ID, 'C')"
                          *ngIf="
                            C.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == C.ID &&
                            ScreenName == 'STUDY UNIT'
                          "
                          (click)="EditStudyUnit(C, 'C', i, j)"
                        >
                          <i class="fa fa-edit" title="Edit Study Unit"></i>
                        </button>
                      </div>
                      <!-- EDIT STUDY UNIT2 2 END -->
                       <!-- STUDY UNIT2 SUBJECT LIST 2 START -->
                      <div
                        class="px-1 tree-btn-1"
                        *ngIf="ScreenName == 'STUDY UNIT'"
                        (mouseenter)="OnSelect(C.ID, 'C')"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          (mouseenter)="OnSelect(C.ID, 'C')"
                          *ngIf="
                            C.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == C.ID &&
                            ScreenName == 'STUDY UNIT'
                          "
                          (click)="ShowSubjectlist(C)"
                        >
                          <i class="fa fa-bars" title="Study Unit Subject"></i>
                        </button>
                      </div>
                       <!-- STUDY UNIT2 SUBJECT LIST 2 END -->
                        <!-- ASSIGN STUDY UNIT2 START 2 -->
                        <div
                        *ngIf="
                          C.ChildNodeExistInd === 'Y'&&
                            C.Study_Unit_Ind === 'Y'&&
                            ScreenName == 'STUDY UNIT2'"
                        class="px-1 tree-btn-1"
                        (mouseenter)="OnSelect(C.ID, 'C')"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          (mouseenter)="OnSelect(C.ID, 'C')"
                          *ngIf="
                          C.ChildNodeExistInd === 'Y'&&
                            C.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == C.ID &&
                            ScreenName == 'STUDY UNIT2'
                          "
                          (click)="AssignStudyMaterial(C)"
                        >
                        <i class="fa fa-link" title="Assign Study Material"></i>
                        </button>
                      </div>
                        <!-- ASSIGN STUDY UNIT2 END 2 -->

                      <div
                      class="px-1 tree-btn-1"
                      *ngIf="ScreenName == 'STUDY UNIT2'"
                      (mouseenter)="OnSelect(C.ID, 'C')"
                    >
                      <button
                        type="button"
                        attr.id="viewquestion{{ i }}"
                        class="tree-btn"
                        (mouseenter)="OnSelect(C.ID, 'C')"
                        *ngIf="
                          C.Study_Unit_Ind === 'Y' &&
                          enableedit &&
                          selectedvalue == C.ID &&
                          ScreenName == 'STUDY UNIT2'
                        "
                        (click)="AddStudyMaterial(C, 'C', i, j)"
                      >
                        <i class="fa fa-plus" title="Add Study Material"></i>
                      </button>
                    </div>
                    </div>
                  </div>
                  <div class="col-12" *ngIf="C.Data">
                    <div
                      class="row tree-row tree-row-child"
                      *ngFor="let SC1 of C.Data; let k = index"
                      (mouseenter)="
                        OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                      "
                    >
                      <div class="col-12 d-flex">
                        <div
                          class="px-1 tree-btn-1"
                          *ngIf="
                            SC1.ChildNodeExistInd === 'Y' &&
                            SC1.Study_Unit_Ind === 'N'
                          "
                        >
                          <button
                            type="button"
                            (click)="getsubjectData(SC1.ID, 'SC2', i, j, k)"
                            attr.id="plusSC1{{ i }}"
                            class="tree-btn"
                            [hidden]="SC1.ChildNodeExistInd === 'N'"
                          >
                            <i class="fa fa-angle-right" *ngIf="!SC1.Data"></i
                            ><i class="fa fa-angle-down" *ngIf="SC1.Data"></i>
                          </button>
                        </div>
                        <div
                          class="px-1 tree-btn-1"
                          *ngIf="
                            SC1.ChildNodeExistInd === 'Y' &&
                            SC1.Study_Unit_Ind === 'Y'
                          "
                        >
                          <button
                            type="button"
                            (click)="getStudyMaterial(SC1.ID)"
                            attr.id="plusSC1{{ i }}"
                            class="tree-btn"
                            [hidden]="SC1.ChildNodeExistInd === 'N'"
                          >
                            <i
                              class="fa fa-angle-right"
                              *ngIf="selectedstudyunit != SC1.ID"
                            >
                            </i
                            ><i
                              class="fa fa-angle-down"
                              *ngIf="selectedstudyunit == SC1.ID"
                            ></i>
                          </button>
                        </div>
                        <div
                          class="px-1 tree-btn-1"
                          *ngIf="
                            SC1.ChildNodeExistInd === 'N' &&
                            SC1.Study_Unit_Ind === 'Y'
                          "
                        >
                          <button
                            type="button"
                            (click)="getsubjectData(SC1.ID, 'SC2', i, j, k)"
                            attr.id="plusSC1{{ i }}"
                            class="tree-btn"
                            [hidden]="SC1.ChildNodeExistInd === 'N'"
                          >
                            <i class="fa fa-angle-right" *ngIf="!SC1.Data"></i
                            ><i class="fa fa-angle-down" *ngIf="SC1.Data"></i>
                          </button>
                        </div>
                        <div
                          class="px-1 tree-btn-1"
                          *ngIf="
                            SC1.ChildNodeExistInd === 'N' &&
                            SC1.Study_Unit_Ind === 'N'
                          "
                        >
                          <button
                            type="button"
                            (click)="getsubjectData(SC1.ID, 'SC2', i, j, k)"
                            attr.id="plusSC1{{ i }}"
                            class="tree-btn"
                            [hidden]="SC1.ChildNodeExistInd === 'N'"
                          >
                            <i class="fa fa-angle-right" *ngIf="!SC1.Data"></i
                            ><i class="fa fa-angle-down" *ngIf="SC1.Data"></i>
                          </button>
                        </div>
                        <app-tree-content
                          Text="{{ SC1.Name }}"
                          status="{{ SC1.Status_Code }}"
                          ID="{{ SC1.ID }}"
                          (mouseenter)="
                            OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                          "
                        ></app-tree-content>
                        <div
                          class="px-1 tree-btn-1"
                          *ngIf="
                            SC1.Study_Unit_Ind === 'N' &&
                            enableedit &&
                            selectedvalue == SC1.ID&&
                            ScreenName == 'STUDY UNIT' &&
                            (selectedkey === 'C' || selectedkey === 'SCL1')
                          "
                          (mouseenter)="
                            OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                          "
                        >
                          <button
                            type="button"
                            [hidden]="
                              SC1.ChildNodeExistInd === 'N' &&
                              SC1.Study_Unit_Ind === 'N'
                            "
                            (mouseenter)="
                              OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                            "
                            attr.id="viewquestion{{ i }}"
                            class="tree-btn"
                            *ngIf="
                              SC1.Study_Unit_Ind === 'N' &&
                              enableedit &&
                              selectedvalue == SC1.ID &&
                              (selectedkey === 'C' || selectedkey === 'SCL1') &&
                              ScreenName == 'STUDY UNIT'
                            "
                            (click)="AddStudyUnit(SC1, 'SC1', i, j, k)"
                          >
                            <i class="fa fa-plus" title="Add Study Unit"></i>
                          </button>
                        </div>
                        <div
                          class="px-1 tree-btn-1"
                          *ngIf="ScreenName == 'STUDY UNIT'"
                          (mouseenter)="
                            OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                          "
                        >
                          <button
                            type="button"
                            (mouseenter)="
                              OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                            "
                            attr.id="viewquestion{{ i }}"
                            class="tree-btn"
                            *ngIf="
                              SC1.Study_Unit_Ind === 'Y' &&
                              enableedit &&
                              selectedvalue == SC1.ID &&
                              ScreenName == 'STUDY UNIT'
                            "
                            (click)="EditStudyUnit(SC1, 'SC1', i, j, k)"
                          >
                            <i class="fa fa-edit" title="Edit Study Unit"></i>
                          </button>
                        </div>
                        <div
                        class="px-1 tree-btn-1"
                        *ngIf="ScreenName == 'STUDY UNIT'"
                        (mouseenter)="
                          OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                        "
                      >
                        <button
                          type="button"
                          (mouseenter)="
                            OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                          "
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          *ngIf="
                            SC1.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == SC1.ID &&
                            ScreenName == 'STUDY UNIT'
                          "
                          (click)="ShowSubjectlist(SC1)"
                        >
                          <i
                            class="fa fa-bars"
                            title="Study Unit Subject"
                          ></i>
                        </button>
                      </div>
                        <!-- ASSIGN STUDY UNIT2 START 3 -->
                        <div
                        *ngIf="
                          SC1.ChildNodeExistInd === 'Y'&&
                            SC1.Study_Unit_Ind === 'Y'&&
                            ScreenName == 'STUDY UNIT2'"
                        class="px-1 tree-btn-1"
                        (mouseenter)="OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          (mouseenter)="OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)"
                          *ngIf="
                          SC1.ChildNodeExistInd === 'Y'&&
                            SC1.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == SC1.ID &&
                            ScreenName == 'STUDY UNIT2'
                          "
                          (click)="AssignStudyMaterial(SC1)"
                        >
                        <i class="fa fa-link" title="Assign Study Material"></i>
                        </button>
                      </div>
                <!-- ASSIGN STUDY UNIT2 END 3 -->

                        <div
                        class="px-1 tree-btn-1"
                        *ngIf="ScreenName == 'STUDY UNIT2'"
                        (mouseenter)="
                          OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                        "
                      >
                        <button
                          type="button"
                          (mouseenter)="
                            OnSelect(SC1.ID, SC1.Subject_Level_Type_Code)
                          "
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          *ngIf="
                            SC1.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == SC1.ID &&
                            ScreenName == 'STUDY UNIT2'
                          "
                          (click)="AddStudyMaterial(SC1, 'SC1', i, j, k)"
                        >
                          <i
                            class="fa fa-plus"
                            title="Add Study Material"
                          ></i>
                        </button>
                      </div>
                      </div>
                      <div class="col-12" *ngIf="SC1.Data">
                        <div
                          class="row tree-row tree-row-child"
                          *ngFor="let SC2 of SC1.Data; let l = index"
                          (mouseenter)="
                            OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                          "
                        >
                          <div class="col-12 d-flex">
                            <div
                              class="px-1 tree-btn-1"
                              *ngIf="
                                SC2.ChildNodeExistInd === 'Y' &&
                                SC2.Study_Unit_Ind === 'N'
                              "
                            >
                              <button
                                type="button"
                                class="tree-btn"
                                (click)="
                                  getsubjectData(SC2.ID, 'SC3', i, j, k, l)
                                "
                                attr.id="plusSC2{{ i }}"
                                [hidden]="SC2.ChildNodeExistInd === 'N'"
                              >
                                <i
                                  class="fa fa-angle-right"
                                  *ngIf="!SC2.Data"
                                ></i>
                                <i
                                  class="fa fa-angle-down"
                                  *ngIf="SC2.Data"
                                ></i>
                              </button>
                            </div>
                            <div
                              class="px-1 tree-btn-1"
                              *ngIf="
                                SC2.ChildNodeExistInd === 'Y' &&
                                SC2.Study_Unit_Ind === 'Y'
                              "
                            >
                              <button
                                type="button"
                                class="tree-btn"
                                (click)="getStudyMaterial(SC2.ID)"
                                attr.id="plusSC2{{ i }}"
                                [hidden]="SC2.ChildNodeExistInd === 'N'"
                              >
                                <i
                                  class="fa fa-angle-right"
                                  *ngIf="selectedstudyunit != SC2.ID"
                                ></i>
                                <i
                                  class="fa fa-angle-down"
                                  *ngIf="selectedstudyunit == SC2.ID"
                                ></i>
                              </button>
                            </div>
                            <div
                              class="px-1 tree-btn-1"
                              *ngIf="
                                SC2.ChildNodeExistInd === 'N' &&
                                SC2.Study_Unit_Ind === 'Y'
                              "
                            >
                              <button
                                type="button"
                                class="tree-btn"
                                (click)="
                                  getsubjectData(SC2.ID, 'SC3', i, j, k, l)
                                "
                                attr.id="plusSC2{{ i }}"
                                [hidden]="SC2.ChildNodeExistInd === 'N'"
                              >
                                <i
                                  class="fa fa-angle-right"
                                  *ngIf="!SC2.Data"
                                ></i>
                                <i
                                  class="fa fa-angle-down"
                                  *ngIf="SC2.Data"
                                ></i>
                              </button>
                            </div>
                            <div
                              class="px-1 tree-btn-1"
                              *ngIf="
                                SC2.ChildNodeExistInd === 'N' &&
                                SC2.Study_Unit_Ind === 'N'
                              "
                            >
                              <button
                                type="button"
                                class="tree-btn"
                                (click)="
                                  getsubjectData(SC2.ID, 'SC3', i, j, k, l)
                                "
                                attr.id="plusSC2{{ i }}"
                                [hidden]="SC2.ChildNodeExistInd === 'N'"
                              >
                                <i
                                  class="fa fa-angle-right"
                                  *ngIf="!SC2.Data"
                                ></i>
                                <i
                                  class="fa fa-angle-down"
                                  *ngIf="SC2.Data"
                                ></i>
                              </button>
                            </div>
                            <app-tree-content
                              Text="{{ SC2.Name }}"
                              status="{{ SC2.Status_Code }}"
                              ID="{{ SC2.ID }}"
                              (mouseenter)="
                                OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                              "
                            >
                            </app-tree-content>
                            <div
                              class="px-1 tree-btn-1"
                              *ngIf="
                                SC2.Study_Unit_Ind === 'N' &&
                                enableedit &&
                                selectedvalue == SC2.ID &&
                                ScreenName == 'STUDY UNIT' &&
                                (selectedkey === 'SCL2' ||
                                  selectedkey === 'SCL1')
                              "
                              (mouseenter)="
                                OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                              "
                            >
                              <button
                                type="button"
                                [hidden]="
                                  SC2.ChildNodeExistInd === 'N' &&
                                  SC2.Study_Unit_Ind === 'N'
                                "
                                (mouseenter)="
                                  OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                                "
                                attr.id="viewquestion{{ i }}"
                                class="tree-btn"
                                *ngIf="
                                  SC2.Study_Unit_Ind === 'N' &&
                                  enableedit &&
                                  selectedvalue == SC2.ID &&
                                  (selectedkey === 'SCL2' ||
                                    selectedkey === 'SCL1') &&
                                  ScreenName == 'STUDY UNIT'
                                "
                                (click)="AddStudyUnit(SC2, 'SC2', i, j, k, l)"
                              >
                                <i
                                  class="fa fa-plus"
                                  title="Add Study Unit"
                                ></i>
                              </button>
                            </div>
                            <div
                              class="px-1 tree-btn-1"
                              *ngIf="ScreenName == 'STUDY UNIT'"
                              (mouseenter)="
                                OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                              "
                            >
                              <button
                                type="button"
                                (mouseenter)="
                                  OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                                "
                                attr.id="viewquestion{{ i }}"
                                class="tree-btn"
                                *ngIf="
                                  SC2.Study_Unit_Ind === 'Y' &&
                                  enableedit &&
                                  selectedvalue == SC2.ID &&
                                  ScreenName == 'STUDY UNIT'
                                "
                                (click)="EditStudyUnit(SC2, 'SC2', i, j, k, l)"
                              >
                                <i
                                  class="fa fa-edit"
                                  title="Edit Study Unit"
                                ></i>
                              </button>
                            </div>
                            <div
                              class="px-1 tree-btn-1"
                              *ngIf="ScreenName == 'STUDY UNIT2'"
                              (mouseenter)="
                                OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                              "
                            >
                              <button
                                type="button"
                                (mouseenter)="
                                  OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                                "
                                attr.id="viewquestion{{ i }}"
                                class="tree-btn"
                                *ngIf="
                                  SC2.Study_Unit_Ind === 'Y' &&
                                  enableedit &&
                                  selectedvalue == SC2.ID &&
                                  ScreenName == 'STUDY UNIT2'
                                "
                                (click)="
                                  AddStudyMaterial(SC2, 'SC2', i, j, k, l)
                                "
                              >
                                <i
                                  class="fa fa-plus"
                                  title="Add Study Material"
                                ></i>
                              </button>
                            </div>
                            <div
                              class="px-1 tree-btn-1"
                              *ngIf="ScreenName == 'STUDY UNIT'"
                              (mouseenter)="
                                OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                              "
                            >
                              <button
                                type="button"
                                (mouseenter)="
                                  OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)
                                "
                                attr.id="viewquestion{{ i }}"
                                class="tree-btn"
                                *ngIf="
                                  SC2.Study_Unit_Ind === 'Y' &&
                                  enableedit &&
                                  selectedvalue == SC2.ID &&
                                  ScreenName == 'STUDY UNIT'
                                "
                                (click)="ShowSubjectlist(SC2)"
                              >
                                <i
                                  class="fa fa-bars"
                                  title="Study Unit Subject"
                                ></i>
                              </button>
                            </div>
                        <!-- ASSIGN STUDY UNIT2 START 4 -->
                        <div
                        *ngIf="
                          SC2.ChildNodeExistInd === 'Y'&&
                            SC2.Study_Unit_Ind === 'Y'&&
                            ScreenName == 'STUDY UNIT2'"
                        class="px-1 tree-btn-1"
                        (mouseenter)="OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          (mouseenter)="OnSelect(SC2.ID, SC2.Subject_Level_Type_Code)"
                          *ngIf="
                          SC2.ChildNodeExistInd === 'Y'&&
                            SC2.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == SC2.ID &&
                            ScreenName == 'STUDY UNIT2'
                          "
                          (click)="AssignStudyMaterial(SC2)"
                        >
                        <i class="fa fa-link" title="Assign Study Material"></i>
                        </button>
                      </div>
                <!-- ASSIGN STUDY UNIT2 END 4 -->
                          </div>
                          <div class="col-12" *ngIf="SC2.Data">
                            <div
                              class="row tree-row tree-row-child"
                              *ngFor="let SC3 of SC2.Data; let m = index"
                              (mouseenter)="
                                OnSelect(SC3.ID, SC3.Subject_Level_Type_Code)
                              "
                            >
                              <div class="col-12 d-flex">
                                <div
                                  class="px-1 tree-btn-1"
                                  *ngIf="
                                    SC3.ChildNodeExistInd === 'Y' &&
                                    SC3.Study_Unit_Ind === 'N'
                                  "
                                >
                                  <button
                                    type="button"
                                    class="tree-btn"
                                    (click)="
                                      getsubjectData(
                                        SC3.ID,
                                        'SC4',
                                        i,
                                        j,
                                        k,
                                        l,
                                        m
                                      )
                                    "
                                    attr.id="plusSC3{{ i }}"
                                    [hidden]="SC3.ChildNodeExistInd === 'N'"
                                  >
                                    <i
                                      class="fa fa-angle-right"
                                      *ngIf="!SC3.Data"
                                    ></i>
                                    <i
                                      class="fa fa-angle-down"
                                      *ngIf="SC3.Data"
                                    ></i>
                                  </button>
                                </div>
                                <div
                                  class="px-1 tree-btn-1"
                                  *ngIf="
                                    SC3.ChildNodeExistInd === 'Y' &&
                                    SC3.Study_Unit_Ind === 'Y'
                                  "
                                >
                                  <button
                                    type="button"
                                    class="tree-btn"
                                    (click)="getStudyMaterial(SC3.ID)"
                                    attr.id="plusSC3{{ i }}"
                                    [hidden]="SC3.ChildNodeExistInd === 'N'"
                                  >
                                    <i
                                      class="fa fa-angle-right"
                                      *ngIf="selectedstudyunit != SC3.ID"
                                    ></i>
                                    <i
                                      class="fa fa-angle-down"
                                      *ngIf="selectedstudyunit == SC3.ID"
                                    ></i>
                                  </button>
                                </div>
                                <div
                                  class="px-1 tree-btn-1"
                                  *ngIf="
                                    SC3.ChildNodeExistInd === 'N' &&
                                    SC3.Study_Unit_Ind === 'Y'
                                  "
                                >
                                  <button
                                    type="button"
                                    class="tree-btn"
                                    (click)="
                                      getsubjectData(
                                        SC3.ID,
                                        'SC4',
                                        i,
                                        j,
                                        k,
                                        l,
                                        m
                                      )
                                    "
                                    attr.id="plusSC3{{ i }}"
                                    [hidden]="SC3.ChildNodeExistInd === 'N'"
                                  >
                                    <i
                                      class="fa fa-angle-right"
                                      *ngIf="!SC3.Data"
                                    ></i>
                                    <i
                                      class="fa fa-angle-down"
                                      *ngIf="SC3.Data"
                                    ></i>
                                  </button>
                                </div>
                                <div
                                  class="px-1 tree-btn-1"
                                  *ngIf="
                                    SC3.ChildNodeExistInd === 'N' &&
                                    SC3.Study_Unit_Ind === 'N'
                                  "
                                >
                                  <button
                                    type="button"
                                    class="tree-btn"
                                    (click)="
                                      getsubjectData(
                                        SC3.ID,
                                        'SC4',
                                        i,
                                        j,
                                        k,
                                        l,
                                        m
                                      )
                                    "
                                    attr.id="plusSC3{{ i }}"
                                    [hidden]="SC3.ChildNodeExistInd === 'N'"
                                  >
                                    <i
                                      class="fa fa-angle-right"
                                      *ngIf="!SC3.Data"
                                    ></i>
                                    <i
                                      class="fa fa-angle-down"
                                      *ngIf="SC3.Data"
                                    ></i>
                                  </button>
                                </div>
                                <app-tree-content
                                  Text="{{ SC3.Name }}"
                                  status="{{ SC3.Status_Code }}"
                                  ID="{{ SC3.ID }}"
                                  (mouseenter)="
                                    OnSelect(
                                      SC3.ID,
                                      SC3.Subject_Level_Type_Code
                                    )
                                  "
                                >
                                </app-tree-content>
                                <div
                                  class="px-1 tree-btn-1"
                                  *ngIf="
                                    SC3.Study_Unit_Ind === 'N' &&
                                    enableedit &&
                                    selectedvalue == SC3.ID &&
                                    ScreenName == 'STUDY UNIT' &&
                                    (selectedkey === 'SCL3' ||
                                      selectedkey === 'SCL2')
                                  "
                                  (mouseenter)="
                                    OnSelect(
                                      SC3.ID,
                                      SC3.Subject_Level_Type_Code
                                    )
                                  "
                                >
                                  <button
                                    type="button"
                                    [hidden]="
                                      SC3.ChildNodeExistInd === 'N' &&
                                      SC3.Study_Unit_Ind === 'N'
                                    "
                                    (mouseenter)="
                                      OnSelect(
                                        SC3.ID,
                                        SC3.Subject_Level_Type_Code
                                      )
                                    "
                                    attr.id="viewquestion{{ i }}"
                                    class="tree-btn"
                                    *ngIf="
                                      SC3.Study_Unit_Ind === 'N' &&
                                      enableedit &&
                                      selectedvalue == SC3.ID &&
                                      (selectedkey === 'SCL3' ||
                                        selectedkey === 'SCL2') &&
                                      ScreenName == 'STUDY UNIT'
                                    "
                                    (click)="
                                      AddStudyUnit(SC3, 'SC3', i, j, k, l, m)
                                    "
                                  >
                                    <i
                                      class="fa fa-plus"
                                      title="Add Study Unit"
                                    ></i>
                                  </button>
                                </div>
                                <div
                                  class="px-1 tree-btn-1"
                                  *ngIf="ScreenName == 'STUDY UNIT'"
                                  (mouseenter)="
                                    OnSelect(
                                      SC3.ID,
                                      SC3.Subject_Level_Type_Code
                                    )
                                  "
                                >
                                  <button
                                    type="button"
                                    (mouseenter)="
                                      OnSelect(
                                        SC3.ID,
                                        SC3.Subject_Level_Type_Code
                                      )
                                    "
                                    attr.id="viewquestion{{ i }}"
                                    class="tree-btn"
                                    *ngIf="
                                      SC3.Study_Unit_Ind === 'Y' &&
                                      enableedit &&
                                      selectedvalue == SC3.ID &&
                                      ScreenName == 'STUDY UNIT'
                                    "
                                    (click)="
                                      EditStudyUnit(SC3, 'SC3', i, j, k, l, m)
                                    "
                                  >
                                    <i
                                      class="fa fa-edit"
                                      title="Edit Study Unit"
                                    ></i>
                                  </button>
                                </div>
                                <div
                                  class="px-1 tree-btn-1"
                                  *ngIf="ScreenName == 'STUDY UNIT2'"
                                  (mouseenter)="
                                    OnSelect(
                                      SC3.ID,
                                      SC3.Subject_Level_Type_Code
                                    )
                                  "
                                >
                                  <button
                                    type="button"
                                    (mouseenter)="
                                      OnSelect(
                                        SC3.ID,
                                        SC3.Subject_Level_Type_Code
                                      )
                                    "
                                    attr.id="viewquestion{{ i }}"
                                    class="tree-btn"
                                    *ngIf="
                                      SC3.Study_Unit_Ind === 'Y' &&
                                      enableedit &&
                                      selectedvalue == SC3.ID &&
                                      ScreenName == 'STUDY UNIT2'
                                    "
                                    (click)="
                                      AddStudyMaterial(
                                        SC3,
                                        'SC3',
                                        i,
                                        j,
                                        k,
                                        l,
                                        m
                                      )
                                    "
                                  >
                                    <i
                                      class="fa fa-plus"
                                      title="Add Study Material"
                                    ></i>
                                  </button>
                                </div>
                                                        <!-- ASSIGN STUDY UNIT2 START 5 -->
                        <div
                        *ngIf="
                          SC3.ChildNodeExistInd === 'Y'&&
                            SC3.Study_Unit_Ind === 'Y'&&
                            ScreenName == 'STUDY UNIT2'"
                        class="px-1 tree-btn-1"
                        (mouseenter)="OnSelect(SC3.ID, SC3.Subject_Level_Type_Code)"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          (mouseenter)="OnSelect(SC3.ID, SC3.Subject_Level_Type_Code)"
                          *ngIf="
                          SC3.ChildNodeExistInd === 'Y'&&
                            SC3.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == SC3.ID &&
                            ScreenName == 'STUDY UNIT2'
                          "
                          (click)="AssignStudyMaterial(SC3)"
                        >
                        <i class="fa fa-link" title="Assign Study Material"></i>
                        </button>
                      </div>
                <!-- ASSIGN STUDY UNIT2 END 5 -->
                                <div
                                  class="px-1 tree-btn-1"
                                  (mouseenter)="
                                    OnSelect(
                                      SC3.ID,
                                      SC3.Subject_Level_Type_Code
                                    )
                                  "
                                  *ngIf="ScreenName == 'STUDY UNIT'"
                                >
                                  <button
                                    type="button"
                                    (mouseenter)="
                                      OnSelect(
                                        SC3.ID,
                                        SC3.Subject_Level_Type_Code
                                      )
                                    "
                                    attr.id="viewquestion{{ i }}"
                                    class="tree-btn"
                                    *ngIf="
                                      SC3.Study_Unit_Ind === 'Y' &&
                                      enableedit &&
                                      selectedvalue == SC3.ID &&
                                      ScreenName == 'STUDY UNIT'
                                    "
                                    (click)="ShowSubjectlist(SC3)"
                                  >
                                    <i
                                      class="fa fa-bars"
                                      title="Study Unit Subject"
                                    ></i>
                                  </button>
                                </div>
                              </div>
                              <div class="col-12" *ngIf="SC3.Data">
                                <div
                                  class="row tree-row tree-row-child"
                                  *ngFor="let SC4 of SC3.Data; let n = index"
                                  (mouseenter)="
                                    OnSelect(
                                      SC4.ID,
                                      SC4.Subject_Level_Type_Code
                                    )
                                  "
                                >
                                  <div class="col-12 d-flex">
                                    <div
                                      class="px-1 tree-btn-1"
                                      *ngIf="
                                        SC4.ChildNodeExistInd === 'Y' &&
                                        SC4.Study_Unit_Ind === 'N'
                                      "
                                    >
                                      <button
                                        type="button"
                                        class="tree-btn"
                                        (click)="
                                          getsubjectData(
                                            SC4.ID,
                                            'SC5',
                                            i,
                                            j,
                                            k,
                                            l,
                                            m,
                                            n
                                          )
                                        "
                                        [hidden]="SC4.ChildNodeExistInd === 'N'"
                                      >
                                        <i
                                          class="fa fa-angle-right"
                                          *ngIf="!SC4.Data"
                                        ></i>
                                        <i
                                          class="fa fa-angle-down"
                                          *ngIf="SC4.Data"
                                        ></i>
                                      </button>
                                    </div>
                                    <div
                                      class="px-1 tree-btn-1"
                                      *ngIf="
                                        SC4.ChildNodeExistInd === 'Y' &&
                                        SC4.Study_Unit_Ind === 'Y'
                                      "
                                    >
                                      <button
                                        type="button"
                                        class="tree-btn"
                                        (click)="getStudyMaterial(SC4.ID)"
                                        [hidden]="SC4.ChildNodeExistInd === 'N'"
                                      >
                                        <i
                                          class="fa fa-angle-right"
                                          *ngIf="selectedstudyunit != SC4.ID"
                                        ></i>
                                        <i
                                          class="fa fa-angle-down"
                                          *ngIf="selectedstudyunit == SC4.ID"
                                        ></i>
                                      </button>
                                    </div>
                                    <div
                                      class="px-1 tree-btn-1"
                                      *ngIf="
                                        SC4.ChildNodeExistInd === 'N' &&
                                        SC4.Study_Unit_Ind === 'Y'
                                      "
                                    >
                                      <button
                                        type="button"
                                        class="tree-btn"
                                        (click)="
                                          getsubjectData(
                                            SC4.ID,
                                            'SC5',
                                            i,
                                            j,
                                            k,
                                            l,
                                            m,
                                            n
                                          )
                                        "
                                        [hidden]="SC4.ChildNodeExistInd === 'N'"
                                      >
                                        <i
                                          class="fa fa-angle-right"
                                          *ngIf="!SC4.Data"
                                        ></i>
                                        <i
                                          class="fa fa-angle-down"
                                          *ngIf="SC4.Data"
                                        ></i>
                                      </button>
                                    </div>
                                    <div
                                      class="px-1 tree-btn-1"
                                      *ngIf="
                                        SC4.ChildNodeExistInd === 'N' &&
                                        SC4.Study_Unit_Ind === 'N'
                                      "
                                    >
                                      <button
                                        type="button"
                                        class="tree-btn"
                                        (click)="
                                          getsubjectData(
                                            SC4.ID,
                                            'SC5',
                                            i,
                                            j,
                                            k,
                                            l,
                                            m,
                                            n
                                          )
                                        "
                                        [hidden]="SC4.ChildNodeExistInd === 'N'"
                                      >
                                        <i
                                          class="fa fa-angle-right"
                                          *ngIf="!SC4.Data"
                                        ></i>
                                        <i
                                          class="fa fa-angle-down"
                                          *ngIf="SC4.Data"
                                        ></i>
                                      </button>
                                    </div>
                                    <app-tree-content
                                      Text="{{ SC4.Name }}"
                                      status="{{ SC4.Status_Code }}"
                                      ID="{{ SC4.ID }}"
                                      (mouseenter)="
                                        OnSelect(
                                          SC4.ID,
                                          SC4.Subject_Level_Type_Code
                                        )
                                      "
                                    ></app-tree-content>
                                    <div
                                      class="px-1 tree-btn-1"
                                      *ngIf="
                                        SC4.Study_Unit_Ind === 'N' &&
                                        enableedit &&
                                        selectedvalue == SC4.ID &&
                                        ScreenName == 'STUDY UNIT' &&
                                        (selectedkey === 'SCL3' ||
                                          selectedkey === 'SCL4')
                                      "
                                      (mouseenter)="
                                        OnSelect(
                                          SC4.ID,
                                          SC4.Subject_Level_Type_Code
                                        )
                                      "
                                    >
                                      <button
                                        type="button"
                                        [hidden]="
                                          SC4.ChildNodeExistInd === 'N' &&
                                          SC4.Study_Unit_Ind === 'N'
                                        "
                                        (mouseenter)="
                                          OnSelect(
                                            SC4.ID,
                                            SC4.Subject_Level_Type_Code
                                          )
                                        "
                                        attr.id="viewquestion{{ i }}"
                                        class="tree-btn"
                                        *ngIf="
                                          SC4.Study_Unit_Ind === 'N' &&
                                          enableedit &&
                                          selectedvalue == SC4.ID &&
                                          (selectedkey === 'SCL3' ||
                                            selectedkey === 'SCL4') &&
                                          ScreenName == 'STUDY UNIT'
                                        "
                                        (click)="
                                          AddStudyUnit(
                                            SC4,
                                            'SC4',
                                            i,
                                            j,
                                            k,
                                            l,
                                            m,
                                            n
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-plus"
                                          title="Add Study Unit"
                                        ></i>
                                      </button>
                                    </div>
                                    <div
                                      class="px-1 tree-btn-1"
                                      *ngIf="ScreenName == 'STUDY UNIT'"
                                      (mouseenter)="
                                        OnSelect(
                                          SC4.ID,
                                          SC4.Subject_Level_Type_Code
                                        )
                                      "
                                    >
                                      <button
                                        type="button"
                                        (mouseenter)="
                                          OnSelect(
                                            SC4.ID,
                                            SC4.Subject_Level_Type_Code
                                          )
                                        "
                                        attr.id="viewquestion{{ i }}"
                                        class="tree-btn"
                                        *ngIf="
                                          SC4.Study_Unit_Ind === 'Y' &&
                                          enableedit &&
                                          selectedvalue == SC4.ID &&
                                          ScreenName == 'STUDY UNIT'
                                        "
                                        (click)="
                                          EditStudyUnit(
                                            SC4,
                                            'SC4',
                                            i,
                                            j,
                                            k,
                                            l,
                                            m,
                                            n
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-edit"
                                          title="Edit Study Unit"
                                        ></i>
                                      </button>
                                    </div>
                                    <div
                                      class="px-1 tree-btn-1"
                                      *ngIf="ScreenName == 'STUDY UNIT2'"
                                      (mouseenter)="
                                        OnSelect(
                                          SC4.ID,
                                          SC4.Subject_Level_Type_Code
                                        )
                                      "
                                    >
                                      <button
                                        type="button"
                                        (mouseenter)="
                                          OnSelect(
                                            SC4.ID,
                                            SC4.Subject_Level_Type_Code
                                          )
                                        "
                                        attr.id="viewquestion{{ i }}"
                                        class="tree-btn"
                                        *ngIf="
                                          SC4.Study_Unit_Ind === 'Y' &&
                                          enableedit &&
                                          selectedvalue == SC4.ID &&
                                          ScreenName == 'STUDY UNIT2'
                                        "
                                        (click)="
                                          AddStudyMaterial(
                                            SC4,
                                            'SC4',
                                            i,
                                            j,
                                            k,
                                            l,
                                            m,
                                            n
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-plus"
                                          title="Add Study Material"
                                        ></i>
                                      </button>
                                    </div>

                                    <div
                                      class="px-1 tree-btn-1"
                                      *ngIf="ScreenName == 'STUDY UNIT'"
                                      (mouseenter)="
                                        OnSelect(
                                          SC4.ID,
                                          SC4.Subject_Level_Type_Code
                                        )
                                      "
                                    >
                                      <button
                                        type="button"
                                        (mouseenter)="
                                          OnSelect(
                                            SC4.ID,
                                            SC4.Subject_Level_Type_Code
                                          )
                                        "
                                        attr.id="viewquestion{{ i }}"
                                        class="tree-btn"
                                        *ngIf="
                                          SC4.Study_Unit_Ind === 'Y' &&
                                          enableedit &&
                                          selectedvalue == SC4.ID &&
                                          ScreenName == 'STUDY UNIT'
                                        "
                                        (click)="ShowSubjectlist(SC4)"
                                      >
                                        <i
                                          class="fa fa-bars"
                                          title="Study Unit Subject"
                                        ></i>
                                      </button>
                                    </div>
                                                      <!-- ASSIGN STUDY UNIT2 START 6 -->
                                    <div
                                    *ngIf="
                                      SC4.ChildNodeExistInd === 'Y'&&
                                        SC4.Study_Unit_Ind === 'Y'&&
                                        ScreenName == 'STUDY UNIT2'"
                                    class="px-1 tree-btn-1"
                                    (mouseenter)="OnSelect(SC4.ID, SC4.Subject_Level_Type_Code)"
                                  >
                                    <button
                                      type="button"
                                      attr.id="viewquestion{{ i }}"
                                      class="tree-btn"
                                      (mouseenter)="OnSelect(SC4.ID, SC4.Subject_Level_Type_Code)"
                                      *ngIf="
                                      SC4.ChildNodeExistInd === 'Y'&&
                                        SC4.Study_Unit_Ind === 'Y' &&
                                        enableedit &&
                                        selectedvalue == SC4.ID &&
                                        ScreenName == 'STUDY UNIT2'
                                      "
                                      (click)="AssignStudyMaterial(SC4)"
                                    >
                                    <i class="fa fa-link" title="Assign Study Material"></i>
                                    </button>
                                  </div>
                            <!-- ASSIGN STUDY UNIT2 END 6 -->
                                  </div>
                                  <div class="col-12" *ngIf="SC4.Data">
                                    <div
                                      class="row tree-row tree-row-child"
                                      *ngFor="
                                        let SC5 of SC4.Data;
                                        let o = index
                                      "
                                      (mouseenter)="
                                        OnSelect(
                                          SC5.ID,
                                          SC5.Subject_Level_Type_Code
                                        )
                                      "
                                    >
                                      <div class="col-12 d-flex">
                                        <div
                                          class="px-1 tree-btn-1"
                                          *ngIf="
                                            SC5.ChildNodeExistInd === 'Y' &&
                                            SC5.Study_Unit_Ind === 'N'
                                          "
                                        >
                                          <button
                                            type="button"
                                            class="tree-btn"
                                            (click)="
                                              getsubjectData(
                                                SC5.ID,
                                                'SC6',
                                                i,
                                                j,
                                                k,
                                                l,
                                                m,
                                                n,
                                                o
                                              )
                                            "
                                            [hidden]="
                                              SC5.ChildNodeExistInd === 'N'
                                            "
                                          >
                                            <i
                                              class="fa fa-angle-right"
                                              *ngIf="!SC5.Data"
                                            ></i>
                                            <i
                                              class="fa fa-angle-down"
                                              *ngIf="SC5.Data"
                                            ></i>
                                          </button>
                                        </div>
                                        <div
                                          class="px-1 tree-btn-1"
                                          *ngIf="
                                            SC5.ChildNodeExistInd === 'Y' &&
                                            SC5.Study_Unit_Ind === 'Y'
                                          "
                                        >
                                          <button
                                            type="button"
                                            class="tree-btn"
                                            (click)="getStudyMaterial(SC5.ID)"
                                            [hidden]="
                                              SC5.ChildNodeExistInd === 'N'
                                            "
                                          >
                                            <i
                                              class="fa fa-angle-right"
                                              *ngIf="
                                                selectedstudyunit != SC5.ID
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-angle-down"
                                              *ngIf="
                                                selectedstudyunit == SC5.ID
                                              "
                                            ></i>
                                          </button>
                                        </div>
                                        <div
                                          class="px-1 tree-btn-1"
                                          *ngIf="
                                            SC5.ChildNodeExistInd === 'N' &&
                                            SC5.Study_Unit_Ind === 'Y'
                                          "
                                        >
                                          <button
                                            type="button"
                                            class="tree-btn"
                                            (click)="
                                              getsubjectData(
                                                SC5.ID,
                                                'SC6',
                                                i,
                                                j,
                                                k,
                                                l,
                                                m,
                                                n,
                                                o
                                              )
                                            "
                                            [hidden]="
                                              SC5.ChildNodeExistInd === 'N'
                                            "
                                          >
                                            <i
                                              class="fa fa-angle-right"
                                              *ngIf="!SC5.Data"
                                            ></i>
                                            <i
                                              class="fa fa-angle-down"
                                              *ngIf="SC5.Data"
                                            ></i>
                                          </button>
                                        </div>
                                        <div
                                          class="px-1 tree-btn-1"
                                          *ngIf="
                                            SC5.ChildNodeExistInd === 'N' &&
                                            SC5.Study_Unit_Ind === 'N'
                                          "
                                        >
                                          <button
                                            type="button"
                                            class="tree-btn"
                                            (click)="
                                              getsubjectData(
                                                SC5.ID,
                                                'SC6',
                                                i,
                                                j,
                                                k,
                                                l,
                                                m,
                                                n,
                                                o
                                              )
                                            "
                                            [hidden]="
                                              SC5.ChildNodeExistInd === 'N'
                                            "
                                          >
                                            <i
                                              class="fa fa-angle-right"
                                              *ngIf="!SC5.Data"
                                            ></i>
                                            <i
                                              class="fa fa-angle-down"
                                              *ngIf="SC5.Data"
                                            ></i>
                                          </button>
                                        </div>
                                        <app-tree-content
                                          Text="{{ SC5.Name }}"
                                          status="{{ SC5.Status_Code }}"
                                          ID="{{ SC5.ID }}"
                                          (mouseenter)="
                                            OnSelect(
                                              SC5.ID,
                                              SC5.Subject_Level_Type_Code
                                            )
                                          "
                                        ></app-tree-content>
                                        <div
                                          class="px-1 tree-btn-1"
                                          *ngIf="
                                            SC5.Study_Unit_Ind === 'N' &&
                                            enableedit &&
                                            selectedvalue == SC5.ID &&
                                            ScreenName == 'STUDY UNIT' &&
                                            (selectedkey === 'SCL5' ||
                                              selectedkey === 'SCL4')
                                          "
                                          (mouseenter)="
                                            OnSelect(
                                              SC5.ID,
                                              SC5.Subject_Level_Type_Code
                                            )
                                          "
                                        >
                                          <button
                                            type="button"
                                            attr.id="viewquestion{{ i }}"
                                            class="tree-btn"
                                            [hidden]="
                                              SC5.ChildNodeExistInd === 'N' &&
                                              SC5.Study_Unit_Ind === 'N'
                                            "
                                            (mouseenter)="
                                              OnSelect(
                                                SC5.ID,
                                                SC5.Subject_Level_Type_Code
                                              )
                                            "
                                            *ngIf="
                                              SC5.Study_Unit_Ind === 'N' &&
                                              enableedit &&
                                              selectedvalue == SC5.ID &&
                                              (selectedkey === 'SCL5' ||
                                              selectedkey === 'SCL4') &&
                                              ScreenName == 'STUDY UNIT'
                                            "
                                            (click)="
                                              AddStudyUnit(
                                                SC5,
                                                'SC5',
                                                i,
                                                j,
                                                k,
                                                l,
                                                m,
                                                n,
                                                o
                                              )
                                            "
                                          >
                                            <i
                                              class="fa fa-plus"
                                              title="Add Study Unit"
                                            ></i>
                                          </button>
                                        </div>
                                        <div
                                          class="px-1 tree-btn-1"
                                          *ngIf="ScreenName == 'STUDY UNIT'"
                                          (mouseenter)="
                                            OnSelect(
                                              SC5.ID,
                                              SC5.Subject_Level_Type_Code
                                            )
                                          "
                                        >
                                          <button
                                            type="button"
                                            attr.id="viewquestion{{ i }}"
                                            class="tree-btn"
                                            (mouseenter)="
                                              OnSelect(
                                                SC5.ID,
                                                SC5.Subject_Level_Type_Code
                                              )
                                            "
                                            *ngIf="
                                              SC5.Study_Unit_Ind === 'Y' &&
                                              enableedit &&
                                              selectedvalue == SC5.ID &&
                                              ScreenName == 'STUDY UNIT'
                                            "
                                            (click)="
                                              EditStudyUnit(
                                                SC5,
                                                'SC5',
                                                i,
                                                j,
                                                k,
                                                l,
                                                m,
                                                n,
                                                o
                                              )
                                            "
                                          >
                                            <i
                                              class="fa fa-edit"
                                              title="Edit Study Unit"
                                            ></i>
                                          </button>
                                        </div>
                                        <div
                                          class="px-1 tree-btn-1"
                                          *ngIf="ScreenName == 'STUDY UNIT2'"
                                          (mouseenter)="
                                            OnSelect(
                                              SC5.ID,
                                              SC5.Subject_Level_Type_Code
                                            )
                                          "
                                        >
                                          <button
                                            type="button"
                                            attr.id="viewquestion{{ i }}"
                                            class="tree-btn"
                                            (mouseenter)="
                                              OnSelect(
                                                SC5.ID,
                                                SC5.Subject_Level_Type_Code
                                              )
                                            "
                                            *ngIf="
                                              SC5.Study_Unit_Ind === 'Y' &&
                                              enableedit &&
                                              selectedvalue == SC5.ID &&
                                              ScreenName == 'STUDY UNIT2'
                                            "
                                            (click)="
                                              AddStudyMaterial(
                                                SC5,
                                                'SC5',
                                                i,
                                                j,
                                                k,
                                                l,
                                                m,
                                                n,
                                                o
                                              )
                                            "
                                          >
                                            <i
                                              class="fa fa-plus"
                                              title="Add Study Material"
                                            ></i>
                                          </button>
                                        </div>
                                                                <!-- ASSIGN STUDY UNIT2 START 7 -->
                        <div
                        *ngIf="
                          SC5.ChildNodeExistInd === 'Y'&&
                            SC5.Study_Unit_Ind === 'Y'&&
                            ScreenName == 'STUDY UNIT2'"
                        class="px-1 tree-btn-1"
                        (mouseenter)="OnSelect(SC5.ID, SC5.Subject_Level_Type_Code)"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          (mouseenter)="OnSelect(SC5.ID, SC5.Subject_Level_Type_Code)"
                          *ngIf="
                          SC5.ChildNodeExistInd === 'Y'&&
                            SC5.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == SC5.ID &&
                            ScreenName == 'STUDY UNIT2'
                          "
                          (click)="AssignStudyMaterial(SC5)"
                        >
                        <i class="fa fa-link" title="Assign Study Material"></i>
                        </button>
                      </div>
                <!-- ASSIGN STUDY UNIT2 END 7 -->
                                        <div
                                          class="px-1 tree-btn-1"
                                          *ngIf="ScreenName == 'STUDY UNIT'"
                                          (mouseenter)="
                                            OnSelect(
                                              SC5.ID,
                                              SC5.Subject_Level_Type_Code
                                            )
                                          "
                                        >
                                          <button
                                            type="button"
                                            attr.id="viewquestion{{ i }}"
                                            class="tree-btn"
                                            (mouseenter)="
                                              OnSelect(
                                                SC5.ID,
                                                SC5.Subject_Level_Type_Code
                                              )
                                            "
                                            *ngIf="
                                              SC5.Study_Unit_Ind === 'Y' &&
                                              enableedit &&
                                              selectedvalue == SC5.ID && ScreenName == 'STUDY UNIT'
                                            "
                                            (click)="ShowSubjectlist(SC5)"
                                          >
                                            <i
                                              class="fa fa-bars"
                                              title="Study Unit Subject"
                                            ></i>
                                          </button>
                                        </div>
                                      </div>
                                      <div class="col-12" *ngIf="SC5.Data">
                                        <div
                                          class="row tree-row tree-row-child"
                                          *ngFor="
                                            let SC6 of SC5.Data;
                                            let p = index
                                          "
                                          (mouseenter)="
                                            OnSelect(
                                              SC6.ID,
                                              SC6.Subject_Level_Type_Code
                                            )
                                          "
                                        >
                                          <div class="col-12 d-flex">
                                            <div
                                              class="px-1 tree-btn-1"
                                              *ngIf="
                                                SC6.ChildNodeExistInd === 'Y' &&
                                                SC6.Study_Unit_Ind === 'N'
                                              "
                                            >
                                              <button
                                                type="button"
                                                class="tree-btn"
                                                [hidden]="
                                                  SC6.ChildNodeExistInd === 'N'
                                                "
                                              >
                                                <i
                                                  class="fa fa-angle-right"
                                                  *ngIf="!SC6.Data"
                                                ></i>
                                                <i
                                                  class="fa fa-angle-down"
                                                  *ngIf="SC6.Data"
                                                ></i>
                                              </button>
                                            </div>
                                            <div
                                              class="px-1 tree-btn-1"
                                              *ngIf="
                                                SC6.ChildNodeExistInd === 'Y' &&
                                                SC6.Study_Unit_Ind === 'Y'
                                              "
                                            >
                                              <button
                                                type="button"
                                                class="tree-btn"
                                                (click)="
                                                  getStudyMaterial(SC6.ID)
                                                "
                                                [hidden]="
                                                  SC6.ChildNodeExistInd === 'N'
                                                "
                                              >
                                                <i
                                                  class="fa fa-angle-right"
                                                  *ngIf="
                                                    selectedstudyunit != SC6.ID
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-angle-down"
                                                  *ngIf="
                                                    selectedstudyunit == SC6.ID
                                                  "
                                                ></i>
                                              </button>
                                            </div>
                                            <div
                                              class="px-1 tree-btn-1"
                                              *ngIf="
                                                SC6.ChildNodeExistInd === 'N' &&
                                                SC6.Study_Unit_Ind === 'Y'
                                              "
                                            >
                                              <button
                                                type="button"
                                                class="tree-btn"
                                                [hidden]="
                                                  SC6.ChildNodeExistInd === 'N'
                                                "
                                              >
                                                <i
                                                  class="fa fa-angle-right"
                                                  *ngIf="!SC6.Data"
                                                ></i>
                                                <i
                                                  class="fa fa-angle-down"
                                                  *ngIf="SC6.Data"
                                                ></i>
                                              </button>
                                            </div>
                                            <div
                                              class="px-1 tree-btn-1"
                                              *ngIf="
                                                SC6.ChildNodeExistInd === 'N' &&
                                                SC6.Study_Unit_Ind === 'N'
                                              "
                                            >
                                              <button
                                                type="button"
                                                class="tree-btn"
                                                [hidden]="
                                                  SC6.ChildNodeExistInd === 'N'
                                                "
                                              >
                                                <i
                                                  class="fa fa-angle-right"
                                                  *ngIf="!SC6.Data"
                                                ></i>
                                                <i
                                                  class="fa fa-angle-down"
                                                  *ngIf="SC6.Data"
                                                ></i>
                                              </button>
                                            </div>
                                            <app-tree-content
                                              Text="{{ SC6.Name }}"
                                              status="{{ SC6.Status_Code }}"
                                              ID="{{ SC6.ID }}"
                                              (mouseenter)="
                                                OnSelect(
                                                  SC6.ID,
                                                  SC6.Subject_Level_Type_Code
                                                )
                                              "
                                            >
                                            </app-tree-content>
                                            <div
                                              class="px-1 tree-btn-1"
                                              *ngIf="
                                                SC6.Study_Unit_Ind === 'N' &&
                                                enableedit &&
                                                selectedvalue == SC6.ID &&
                                                ScreenName == 'STUDY UNIT' &&
                                                (selectedkey === 'SCL5' ||
                                                  selectedkey === 'SCL6')
                                              "
                                              (mouseenter)="
                                                OnSelect(
                                                  SC6.ID,
                                                  SC6.Subject_Level_Type_Code
                                                )
                                              "
                                            >
                                              <button
                                                type="button"
                                                attr.id="viewquestion{{ i }}"
                                                class="tree-btn"
                                                [hidden]="
                                                  SC6.ChildNodeExistInd ===
                                                    'N' &&
                                                  SC6.Study_Unit_Ind === 'N'
                                                "
                                                (mouseenter)="
                                                  OnSelect(
                                                    SC6.ID,
                                                    SC6.Subject_Level_Type_Code
                                                  )
                                                "
                                                *ngIf="
                                                  SC6.Study_Unit_Ind === 'N' &&
                                                  enableedit &&
                                                  selectedvalue == SC6.ID &&
                                                  (selectedkey === 'SCL5' ||
                                                    selectedkey === 'SCL6') &&
                                                  ScreenName == 'STUDY UNIT'
                                                "
                                                (click)="
                                                  AddStudyUnit(
                                                    SC6,
                                                    'SC6',
                                                    i,
                                                    j,
                                                    k,
                                                    l,
                                                    m,
                                                    n,
                                                    o,
                                                    p
                                                  )
                                                "
                                              >
                                                <i
                                                  class="fa fa-plus"
                                                  title="Add Study Unit"
                                                ></i>
                                              </button>
                                            </div>
                                            <div
                                              class="px-1 tree-btn-1"
                                              *ngIf="ScreenName == 'STUDY UNIT'"
                                              (mouseenter)="
                                                OnSelect(
                                                  SC6.ID,
                                                  SC6.Subject_Level_Type_Code
                                                )
                                              "
                                            >
                                              <button
                                                type="button"
                                                attr.id="viewquestion{{ i }}"
                                                class="tree-btn"
                                                (mouseenter)="
                                                  OnSelect(
                                                    SC6.ID,
                                                    SC6.Subject_Level_Type_Code
                                                  )
                                                "
                                                *ngIf="
                                                  SC6.Study_Unit_Ind === 'Y' &&
                                                  enableedit &&
                                                  selectedvalue == SC6.ID &&
                                                  ScreenName == 'STUDY UNIT'
                                                "
                                                (click)="
                                                  EditStudyUnit(
                                                    SC6,
                                                    'SC6',
                                                    i,
                                                    j,
                                                    k,
                                                    l,
                                                    m,
                                                    n,
                                                    o,
                                                    p
                                                  )
                                                "
                                              >
                                                <i
                                                  class="fa fa-edit"
                                                  title="Edit Study Unit"
                                                ></i>
                                              </button>
                                            </div>
                                            <div
                                              class="px-1 tree-btn-1"
                                              *ngIf="ScreenName == 'STUDY UNIT2'"
                                              (mouseenter)="
                                                OnSelect(
                                                  SC6.ID,
                                                  SC6.Subject_Level_Type_Code
                                                )
                                              "
                                            >
                                              <button
                                                type="button"
                                                attr.id="viewquestion{{ i }}"
                                                class="tree-btn"
                                                (mouseenter)="
                                                  OnSelect(
                                                    SC6.ID,
                                                    SC6.Subject_Level_Type_Code
                                                  )
                                                "
                                                *ngIf="
                                                  SC6.Study_Unit_Ind === 'Y' &&
                                                  enableedit &&
                                                  selectedvalue == SC6.ID &&
                                                  ScreenName == 'STUDY UNIT2'
                                                "
                                                (click)="
                                                  AddStudyMaterial(
                                                    SC6,
                                                    'SC6',
                                                    i,
                                                    j,
                                                    k,
                                                    l,
                                                    m,
                                                    n,
                                                    o,
                                                    p
                                                  )
                                                "
                                              >
                                                <i
                                                  class="fa fa-plus"
                                                  title="Add Study Material"
                                                ></i>
                                              </button>
                                            </div>
                                                                    <!-- ASSIGN STUDY UNIT2 START 8 -->
                        <div
                        *ngIf="
                          SC6.ChildNodeExistInd === 'Y'&&
                            SC6.Study_Unit_Ind === 'Y'&&
                            ScreenName == 'STUDY UNIT2'"
                        class="px-1 tree-btn-1"
                        (mouseenter)="OnSelect(SC6.ID, SC6.Subject_Level_Type_Code)"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          (mouseenter)="OnSelect(SC6.ID, SC6.Subject_Level_Type_Code)"
                          *ngIf="
                          SC6.ChildNodeExistInd === 'Y'&&
                            SC6.Study_Unit_Ind === 'Y' &&
                            enableedit &&
                            selectedvalue == SC6.ID &&
                            ScreenName == 'STUDY UNIT2'
                          "StudyMaterialresponse
                          (click)="AssignStudyMaterial(SC6)"
                        >
                        <i class="fa fa-link" title="Assign Study Material"></i>
                        </button>
                      </div>
                <!-- ASSIGN STUDY UNIT2 END 8 -->
                                            <div
                                              class="px-1 tree-btn-1"
                                              *ngIf="ScreenName == 'STUDY UNIT'"
                                              (mouseenter)="
                                                OnSelect(
                                                  SC6.ID,
                                                  SC6.Subject_Level_Type_Code
                                                )
                                              "
                                            >
                                              <button
                                                type="button"
                                                attr.id="viewquestion{{ i }}"
                                                class="tree-btn"
                                                (mouseenter)="
                                                  OnSelect(
                                                    SC6.ID,
                                                    SC6.Subject_Level_Type_Code
                                                  )
                                                "
                                                *ngIf="
                                                  SC6.Study_Unit_Ind === 'Y' &&
                                                  enableedit &&
                                                  selectedvalue == SC6.ID &&
                                                  ScreenName == 'STUDY UNIT'
                                                "
                                                (click)="ShowSubjectlist(SC6)"
                                              >
                                                <i
                                                  class="fa fa-bars"
                                                  title="Study Unit Subject"
                                                ></i>
                                              </button>
                                            </div>
                                          </div>
                                          <div
                                            class="col-12"
                                            *ngIf="
                                              SC5.ChildNodeExistInd === 'N' &&
                                              enableedit &&
                                              selectedvalue == SC5.ID &&
                                              (selectedkey === 'SCL5' ||
                                                selectedkey === 'SCL6') &&
                                              ScreenName == 'SUBJECT BREAKDOWN'
                                            "
                                          >
                                            <app-tree-add-btn-child
                                              *ngIf="
                                                enableedit &&
                                                selectedvalue == SC4.ID &&
                                                (selectedkey === 'SCL6' ||
                                                  selectedkey === 'SCL5')
                                              "
                                              (mouseenter)="
                                                OnSelect(SC5.ID, 'SCL6')
                                              "
                                              Text="Add Question"
                                              [Primary]="0"
                                            >
                                            </app-tree-add-btn-child>
                                          </div>

                                          <div class="col-12">
                                            <app-content-studymaterial-list
                                              (Editstudymaterial)="
                                                Editstudymaterial($event)
                                              "
                                              *ngIf="
                                                SC5.ChildNodeExistInd === 'Y' &&
                                                SC5.Study_Unit_Ind === 'Y' &&
                                                selectedstudyunit == SC5.ID
                                              "
                                              [StudyMaterialresponse]="
                                                StudyMaterialresponse
                                              "
                                            ></app-content-studymaterial-list>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-12"
                                        *ngIf="
                                          SC5.ChildNodeExistInd === 'N' &&
                                          enableedit &&
                                          selectedvalue == SC5.ID &&
                                          (selectedkey === 'SCL5' ||
                                            selectedkey === 'SCL6') &&
                                          ScreenName == 'SUBJECT BREAKDOWN'
                                        "
                                      >
                                        <app-tree-add-btn-child
                                          *ngIf="
                                            enableedit &&
                                            selectedvalue == SC5.ID &&
                                            (selectedkey === 'SCL5' ||
                                              selectedkey === 'SCL6')
                                          "
                                          (mouseenter)="
                                            OnSelect(SC5.ID, 'SCL6')
                                          "
                                          Text="Add Question"
                                          [Primary]="0"
                                        >
                                        </app-tree-add-btn-child>
                                      </div>

                                      <div class="col-12">
                                        <app-content-studymaterial-list
                                          (Editstudymaterial)="
                                            Editstudymaterial($event)
                                          "
                                          *ngIf="
                                            SC5.ChildNodeExistInd === 'Y' &&
                                            SC5.Study_Unit_Ind === 'Y' &&
                                            selectedstudyunit == SC5.ID
                                          "
                                          [StudyMaterialresponse]="
                                            StudyMaterialresponse
                                          "
                                        ></app-content-studymaterial-list>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-12"
                                    *ngIf="
                                      SC4.ChildNodeExistInd === 'N' &&
                                      enableedit &&
                                      selectedvalue == SC4.ID &&
                                      (selectedkey === 'SCL5' ||
                                        selectedkey === 'SCL4') &&
                                      ScreenName == 'SUBJECT BREAKDOWN'
                                    "
                                  >
                                    <app-tree-add-btn-child
                                      *ngIf="
                                        enableedit &&
                                        selectedvalue == SC4.ID &&
                                        (selectedkey === 'SCL4' ||
                                          selectedkey === 'SCL5')
                                      "
                                      (mouseenter)="OnSelect(SC4.ID, 'SCL5')"
                                      Text="Add Question"
                                      [Primary]="0"
                                    >
                                    </app-tree-add-btn-child>
                                  </div>

                                  <div class="col-12">
                                    <app-content-studymaterial-list
                                      (Editstudymaterial)="
                                        Editstudymaterial($event)
                                      "
                                      *ngIf="
                                        SC4.ChildNodeExistInd === 'Y' &&
                                        SC4.Study_Unit_Ind === 'Y' &&
                                        selectedstudyunit == SC4.ID
                                      "
                                      [StudyMaterialresponse]="
                                        StudyMaterialresponse
                                      "
                                    ></app-content-studymaterial-list>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-12"
                                *ngIf="
                                  SC3.ChildNodeExistInd === 'N' &&
                                  enableedit &&
                                  selectedvalue == SC3.ID &&
                                  (selectedkey === 'SCL4' ||
                                    selectedkey === 'SCL3') &&
                                  ScreenName == 'SUBJECT BREAKDOWN'
                                "
                              >
                                <app-tree-add-btn-child
                                  *ngIf="
                                    enableedit &&
                                    selectedvalue == SC3.ID &&
                                    (selectedkey === 'SCL4' ||
                                      selectedkey === 'SCL3')
                                  "
                                  (mouseenter)="OnSelect(SC3.ID, 'SCL4')"
                                  Text="Add Question"
                                  [Primary]="0"
                                >
                                </app-tree-add-btn-child>
                              </div>

                              <div class="col-12">
                                <app-content-studymaterial-list
                                  (Editstudymaterial)="
                                    Editstudymaterial($event)
                                  "
                                  *ngIf="
                                    SC3.ChildNodeExistInd === 'Y' &&
                                    SC3.Study_Unit_Ind === 'Y' &&
                                    selectedstudyunit == SC3.ID
                                  "
                                  [StudyMaterialresponse]="
                                    StudyMaterialresponse
                                  "
                                ></app-content-studymaterial-list>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-12"
                            *ngIf="
                              SC2.ChildNodeExistInd === 'N' &&
                              enableedit &&
                              selectedvalue == SC2.ID &&
                              (selectedkey === 'SCL2' ||
                                selectedkey === 'SCL3') &&
                              ScreenName == 'SUBJECT BREAKDOWN'
                            "
                          >
                            <app-tree-add-btn-child
                              *ngIf="
                                enableedit &&
                                selectedvalue == SC2.ID &&
                                (selectedkey === 'SCL2' ||
                                  selectedkey === 'SCL3')
                              "
                              (mouseenter)="OnSelect(SC2.ID, 'SCL3')"
                              Text="Add Question"
                              [Primary]="0"
                            >
                            </app-tree-add-btn-child>
                          </div>
                          <div class="col-12">
                            <app-content-studymaterial-list
                              (Editstudymaterial)="Editstudymaterial($event)"
                              *ngIf="
                                SC2.ChildNodeExistInd === 'Y' &&
                                SC2.Study_Unit_Ind === 'Y' &&
                                selectedstudyunit == SC2.ID
                              "
                              [StudyMaterialresponse]="StudyMaterialresponse"
                            ></app-content-studymaterial-list>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12"
                        *ngIf="
                          SC1.ChildNodeExistInd === 'N' &&
                          enableedit &&
                          selectedvalue == SC1.ID &&
                          (selectedkey === 'SCL2' || selectedkey === 'SCL1') &&
                          ScreenName == 'SUBJECT BREAKDOWN'
                        "
                      >
                        <app-tree-add-btn-child
                          *ngIf="
                            enableedit &&
                            selectedvalue == SC1.ID &&
                            (selectedkey === 'SCL2' || selectedkey === 'SCL1')
                          "
                          (mouseenter)="OnSelect(SC1.ID, 'SCL2')"
                          Text="Add Question"
                          [Primary]="0"
                        >
                        </app-tree-add-btn-child>
                      </div>
                      <div class="col-12">
                        <app-content-studymaterial-list
                          (Editstudymaterial)="Editstudymaterial($event)"
                          *ngIf="
                            SC1.ChildNodeExistInd === 'Y' &&
                            SC1.Study_Unit_Ind === 'Y' &&
                            selectedstudyunit == SC1.ID
                          "
                          [StudyMaterialresponse]="StudyMaterialresponse"
                        ></app-content-studymaterial-list>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12"
                    *ngIf="
                      C.ChildNodeExistInd === 'N' &&
                      enableedit &&
                      selectedvalue == C.ID &&
                      (selectedkey === 'C' || selectedkey === 'SCL1') &&
                      ScreenName == 'SUBJECT BREAKDOWN'
                    "
                  >
                    <app-tree-add-btn-child
                      *ngIf="
                        enableedit &&
                        selectedvalue == C.ID &&
                        (selectedkey === 'C' || selectedkey === 'SCL1')
                      "
                      (mouseenter)="OnSelect(C.ID, 'SCL1')"
                      Text="Add Question"
                      [Primary]="0"
                    ></app-tree-add-btn-child>
                  </div>
                  <div class="col-12">
                    <app-content-studymaterial-list
                      (Editstudymaterial)="Editstudymaterial($event)"
                      *ngIf="
                        C.ChildNodeExistInd === 'Y' &&
                        C.Study_Unit_Ind === 'Y' &&
                        selectedstudyunit == C.ID
                      "
                      [StudyMaterialresponse]="StudyMaterialresponse"
                    ></app-content-studymaterial-list>
                  </div>
                </div>
              </div>
              <div
                class="col-12"
                *ngIf="
                  MT.ChildNodeExistInd === 'N' &&
                  enableedit &&
                  selectedvalue == MT.ID &&
                  (selectedkey === 'MT' || selectedkey === 'C') &&
                  ScreenName == 'SUBJECT BREAKDOWN'
                "
              >
                <app-tree-add-btn-child
                  *ngIf="
                    enableedit &&
                    selectedvalue == MT.ID &&
                    (selectedkey === 'C' || selectedkey === 'MT')
                  "
                  (mouseenter)="OnSelect(MT.ID, 'C')"
                  Text="Add Question"
                  [Primary]="0"
                ></app-tree-add-btn-child>
              </div>
              <div class="col-12">
                <app-content-studymaterial-list
                  *ngIf="
                    MT.ChildNodeExistInd === 'Y' &&
                    MT.Study_Unit_Ind === 'Y' &&
                    selectedstudyunit == MT.ID
                  "
                  [StudyMaterialresponse]="StudyMaterialresponse"
                  (Editstudymaterial)="Editstudymaterial($event)"
                ></app-content-studymaterial-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="AddStudyUnitflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Add Study Unit</h6>
        <button
          type="button"
          class="close"
          (click)="CloseStudyUnit()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-study-unit
          [StudyUnitEditList]="StudyUnitEditList"
          [AddStudyUnitflag]="AddStudyUnitflag"
          (cancelbutton)="cancelbutton($event)"
          (StudyUnitClose)="StudyUnitClose($event)"
          (AddStudyUnitSubject)="AddStudyUnitSubject($event)"
          [subjectById]="subjectById"
        ></app-content-study-unit>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" *ngIf="StudyUnitPopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Editdesign">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Add Study Unit Topics
        </h6>
        <button
          type="button"
          class="close"
          (click)="CloseStudyUnitTopics()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-studyunit-topics
          [StudyUnitPopupflag]="StudyUnitPopupflag"
          (CloseSUTopics)="CloseSUTopics($event)"
          [Refresh]="Refresh"
          (getsubjectDataRefresh)="getsubjectDataRefresh($event)"
          (closeall)="closeall($event)"
          [StudyUnitID]="StudyUnitID"
          [subjectById]="subjectById"
        ></app-content-studyunit-topics>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="EditStudyUnitflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Edit Study Unit</h6>
        <button
          type="button"
          class="close"
          [disabled]="validclosebutton"
          (click)="CloseEditStudyUnit()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-study-unit
          [Refresh]="Refresh"
          (getsubjectDataRefresh)="getsubjectDataRefresh($event)"
          [EditStudyUnitflag]="EditStudyUnitflag"
          (cancelbutton)="cancelbutton($event)"
          (StudyUnitClose)="StudyUnitClose($event)"
          (AddStudyUnitSubject)="AddStudyUnitSubject($event)"
          [subjectById]="subjectById"
          [StudyUnitEditList]="StudyUnitEditList"
        ></app-content-study-unit>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="EditStudyUnitTopicflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Editdesign">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Edit Study Unit Topics
        </h6>
        <button
          type="button"
          class="close"
          (click)="CloseEditStudyUnitTopics()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-studyunit-topics
          [EditStudyUnitTopicflag]="EditStudyUnitTopicflag"
          (CloseSUTopics)="CloseSUTopics($event)"
          [Refresh]="Refresh"
          (getsubjectDataRefresh)="getsubjectDataRefresh($event)"
          (closeall)="closeall($event)"
          [StudyUnitID]="StudyUnitID"
          [subjectById]="subjectById"
        ></app-content-studyunit-topics>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade show Model_popup1 d-flex justify-content-center"
  *ngIf="AddStudyMaterialflag"
>
  <div class="modal-dialog-centered" style="width: 90%">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Study Material <span *ngIf="CurrentstudyunitName">({{ CurrentstudyunitName }})</span>
        </h6>
        <button
          type="button"
          class="close"
          (click)="onCLose()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-add-edit-studymaterial
          #contentCmp
          [Replace]="Replace"
          [Close]="Close"
          (ReplaceAlertPopup)="ReplaceAlertPopup($event)"
          (AlertPopup)="AlertPopup($event)"
          [Close1]="Close1"
          [Replace1]="Replace1"
          [Closeclear]="Closeclear"
          [Replaceclear]="Replaceclear"
          [AddStudyMaterialflag]="AddStudyMaterialflag"
          (Editstudymaterial)="Editstudymaterial($event)"
          [ScreenName1]="ScreenName1"
          (contentpreview)="contentpreview($event)"
          (CloseandRefreshlist)="CloseandRefreshlist($event)"
          (CloseEditStudyMaterial)="AddStudyMaterialPopup()"
          [CurrentstudyunitID]="CurrentstudyunitID"
          [subjectById]="subjectById"
          [examAgencyId]="ExamAgencyId"
          [courseId]="courseId"
        ></app-content-add-edit-studymaterial>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="showsubjectlistflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-StudyMaterial1">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Study Unit Subject List
        </h6>
        <button
          type="button"
          class="close"
          (click)="CloseSubject()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-study-unit-subject
          (CloseStudyUnitSubject)="CloseStudyUnitSubject($event)"
          [SubjectlistID]="SubjectlistID"
          [StudyUnit]="StudyUnit"
          [subjectById]="subjectById"
        ></app-content-study-unit-subject>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" *ngIf="EditStudyMaterialflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-StudyMaterial" style="max-width: 90%">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Study Material <span *ngIf="CurrentstudyunitName">({{ CurrentstudyunitName }})</span>
        </h6>
        <button
          type="button"
          class="close"
          (click)="onCLose()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-add-edit-studymaterial
          #contentCmp
          [Closeclear]="Closeclear"
          [Replaceclear]="Replaceclear"
          [Close1]="Close1"
          [Replace1]="Replace1"
          (CloseEditStudyMaterial)="CloseEditStudyMaterial($event)"
          (Editstudymaterial)="Editstudymaterial($event)"
          [ScreenName1]="ScreenName1"
          (ClickContentstatus)="ClickContentstatus($event)"
          (contentreview)="contentreview($event)"
          (contentpreview)="contentpreview($event)"
          (CloseandRefreshlist)="CloseandRefreshlist($event)"
          (closeWithOutRefreshing)="EditStudyMaterialpopup($event)"
          [CurrentstudyunitID]="CurrentstudyunitID"
          [Replace]="Replace"
          [Close]="Close"
          (ReplaceAlertPopup)="ReplaceAlertPopup($event)"
          (AlertPopup)="AlertPopup($event)"
          [EditStudyMaterialflag]="EditStudyMaterialflag"
          [StudyMaterialDetails]="StudyMaterialDetails"
          [subjectById]="subjectById"
          [examAgencyId]="ExamAgencyId"
          [courseId]="courseId"
        ></app-content-add-edit-studymaterial>
      </div>
    </div>
  </div>
  <div class="modal fade show Model_popup1" *ngIf="Contentreviewpopupflag">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">
            Review {{ Contentstatus }} Content
          </h6>
          <button
            type="button"
            class="close"
            (click)="ClkContentclose()"
            style="padding-right: 20px; font-size: 30px; outline: 0"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-content-for-review
            [ScreenName1]="ScreenName1"
            (CloseandRefreshlist)="CloseandRefreshlist($event)"
            (returnreviewpopup)="returnreviewpopup($event)"
            (ReturnContentreviewclose)="ReturnContentreviewclose($event)"
            [Contenttext]="Contenttext"
            [Contentstatus]="Contentstatus"
            [selectedContentById]="selectedContentById"
            [subjectById]="subjectById"
          ></app-content-for-review>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="alertpopup"
>
  <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button
          type="button"
          class="close"
          (click)="CloseAlertpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Study Material Already Exist?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  (click)="CloseAlertpopup()"
                  class="btn btn-sm bl-btn"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="replacealertpopup"
>
  <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button
          type="button"
          class="close"
          (click)="CloseReplacealertpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-3 pt-3">
          <div class="col-12">
            <label>Do you Want to Replace the Existing Study Material?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  (click)="replacebutton()"
                  class="btn btn-sm bl-btn"
                >
                  Yes
                </button>
              </div>
              <div class="px-1">
                <button
                  type="button"
                  (click)="CloseReplacealertpopup()"
                  class="btn btn-sm bg-light border"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="deletealertpopup"
>
  <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button
          type="button"
          class="close"
          (click)="CloseDeleteAlertpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Do you want to delete the Study Material?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  (click)="replacedeletebutton()"
                  class="btn btn-sm bl-btn"
                >
                  Yes
                </button>
              </div>
              <div class="px-1">
                <button
                  type="button"
                  (click)="CloseDeleteAlertpopup()"
                  class="btn btn-sm bg-light border"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="deletealertpopup1"
>
  <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button
          type="button"
          class="close"
          (click)="CloseDeleteAlertpopup1()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Do you want to delete the Study Material?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  (click)="replacedeletebutton1()"
                  class="btn btn-sm bl-btn"
                >
                  Yes
                </button>
              </div>
              <div class="px-1">
                <button
                  type="button"
                  (click)="CloseDeleteAlertpopup1()"
                  class="btn btn-sm bg-light border"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" style="z-index:9999999"  *ngIf="previewpopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Preview Study Material
        </h6>
        <button
          type="button"
          class="close"
          [disabled]="validclosebutton"
          (click)="Closepreview()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-preview
          (returnclosebutton)="returnclosebutton($event)"
          [ScreenName1]="ScreenName1"
          (ClickContentstatus)="ClickContentstatus($event)"
          [StudymaterialFormvalue]="StudymaterialFormvalue"
          [studymateriallist]="studymateriallist"
          [subjectById]="subjectById"
        ></app-content-preview>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="statuspopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Status History</h6>
        <button
          type="button"
          class="close"
          (click)="statuslistpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-studymaterial-statuslist
          (returnstatusclose)="returnstatusclose($event)"
          [Selectedstudymaterial]="Selectedstudymaterial"
        ></app-content-studymaterial-statuslist>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" *ngIf="reviewpopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Review Content</h6>
        <button
          type="button"
          class="close"
          [disabled]="validclosebutton"
          (click)="CloseReviewContent()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-content-reviewcomments
          (ClickContentstatus)="ClickContentstatus($event)"
          (returnreviewclosebutton)="returnreviewclosebutton($event)"
          [ScreenName1]="ScreenName1"
          [StudymaterialFormvalue1]="StudymaterialFormvalue1"
          [studymateriallist1]="studymateriallist1"
          [subjectById]="subjectById"
        ></app-content-reviewcomments>
      </div>
    </div>
  </div>
  <div class="modal fade show Model_popup1" *ngIf="Contentreviewpopupflag">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">
            Review {{ Contentstatus }} Content
          </h6>
          <button
            type="button"
            class="close"
            (click)="ClkContentclose()"
            style="padding-right: 20px; font-size: 30px; outline: 0"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-content-for-review
            [ScreenName1]="ScreenName1"
            (CloseandRefreshlist)="CloseandRefreshlist($event)"
            (returnreviewpopup)="returnreviewpopup($event)"
            (ReturnContentreviewclose)="ReturnContentreviewclose($event)"
            [Contenttext]="Contenttext"
            [Contentstatus]="Contentstatus"
            [selectedContentById]="selectedContentById"
            [subjectById]="subjectById"
          ></app-content-for-review>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="ActivityHisotrypopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Recent Study Materials
        </h6>
        <button
          type="button"
          class="close"
          (click)="ViewActivityHistory()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-3 py-0">
        <div class="row">
          <div class="col-12" style="height: 90vh !important; overflow: auto">
            <div class="row">
              <div class="col-12" *ngIf="ActivityHistorylist">
                <app-tinyedneditor
                  [ContentActivityHistorylist]="ActivityHistorylist"
                  (StudymaterialEditButton)="EditButton($event)"
                  (StudymaterialStatus)="clickstatuspopup($event)"
                ></app-tinyedneditor>
              </div>
            </div>
          </div>
          <!-- <div class="row" *ngIf="ActivityHistoryflag">
            <div class="col-12">
              <app-question-list #childComponent  (RefreshEditQuestion)="RefreshEditQuestion($event)" [subjectById]="subjectById" [questionsubjectresponse]="questionsubjectresponse"></app-question-list>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="Searchmodelpopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-EditSearch">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Search Study Material
        </h6>
        <button
          type="button"
          class="close"
          (click)="SearchQuestionModel()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row">
          <div class="col-12" style="height: 25vh !important; overflow: auto">

            <div class="row pt-2">
              <div class="col-2 p-1 py-0" *ngIf="selectedsubject">
                <div class="p-0">
                  <input
                    type="text"
                    [ngClass]="{ borderview1: !FromDate && ToDate }"
                    required
                    Placeholder="From Date"
                    [(ngModel)]="FromDate"
                    [owlDateTime]="dt1"
                    [owlDateTimeTrigger]="dt1"
                    class="form-control form-control-sm"
                  />
                  <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                </div>
              </div>
              <div class="col-2 p-1 py-0" *ngIf="selectedsubject">
                <div class="p-0">
                  <input
                    type="text"
                    [ngClass]="{ borderview1: FromDate && !ToDate }"
                    Placeholder="To Date"
                    [(ngModel)]="ToDate"
                    [owlDateTime]="dt2"
                    [owlDateTimeTrigger]="dt2"
                    class="form-control form-control-sm"
                  />
                  <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                </div>
              </div>
              <div
                class="col-2 p-1 py-0"
                style="width: 170px"
                *ngIf="selectedsubject"
              >
                <div class="p-0">
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="status"
                  >
                    <option selected value="null" hidden>
                      Study Material Status
                    </option>
                    <option
                      *ngFor="let s of getstatus; let i = index"
                      [value]="s.Code"
                    >
                      {{ s.Description }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="col-2 p-1 py-0"
                style="width: 160px"
                *ngIf="selectedsubject"
              >
                <div class="p-0 pt-1">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      (click)="ClickOwnQuestionInd()"
                      [checked]="OwnQuestionInd"
                    />
                    <label class="form-check-label" for="exampleCheck1"
                      >OwnStudyMaterial</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 px-0 py-1 pt-2">
                <div class="d-flex">
                  <div class="px-1">
                    <button
                      type="button"
                      class="btn btn-sm bl-btn"
                      [disabled]="
                        (!FromDate && !ToDate) ||
                        (FromDate && !ToDate) ||
                        (!FromDate && ToDate)
                      "
                      (click)="FilterQuestion()"
                    >
                      Search
                    </button>
                  </div>
                  <div class="px-1">
                    <button
                      type="button"
                      class="btn btn-sm btn-light bg-light border"
                      (click)="Clear()"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="filtermodelpopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Study Material</h6>
        <button
          type="button"
          class="close"
          (click)="FilterModelpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-3 py-0">
        <div class="row">
          <div class="col-12" style="height: 90vh !important; overflow: auto">
            <div class="row">
              <div class="col-12" *ngIf="getFilterlist">
                <app-tinyedneditor
                  [getFilterlist]="getFilterlist"
                  (StudymaterialEditButton)="EditButton($event)"
                  (StudymaterialStatus)="clickstatuspopup($event)"
                ></app-tinyedneditor>
              </div>
            </div>
          </div>
          <!-- <div class="row" *ngIf="ActivityHistoryflag">
            <div class="col-12">
              <app-question-list #childComponent  (RefreshEditQuestion)="RefreshEditQuestion($event)" [subjectById]="subjectById" [questionsubjectresponse]="questionsubjectresponse"></app-question-list>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
